import { render } from "./InvestorDisplay.vue?vue&type=template&id=4e18c1a8&scoped=true"
import script from "./InvestorDisplay.vue?vue&type=script&lang=ts"
export * from "./InvestorDisplay.vue?vue&type=script&lang=ts"

import "./InvestorDisplay.vue?vue&type=style&index=0&id=4e18c1a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e18c1a8"

export default script